// Scrollmenu
// Change active menu item on scroll

// VAR: Scroll treshold (1 = fullscreen)
if (typeof scrollTreshold == 'undefined') {
	var scrollTreshold = 0.2;
}

// VAR: Keep scroll parent active
if (typeof scrollParent == 'undefined') {
	var scrollParent = true;
}

// VAR: Keep last link active
if (typeof scrollActive == 'undefined') {
	var scrollActive = true;
}


$(window).on('load', scrollMenu);
$(window).on('scroll', scrollMenu);

function scrollMenu() {

	var startScroll = g_scroll;
	var endScroll = g_scroll + (g_windowHeight*scrollTreshold);
	var scrollSection = 0;

	// zoek alle links met data-scroll-link
	$('a[data-scroll-link]').each(function(index,value) {
		scrollSection = $(this).attr('data-scroll-link');

		// zoek alle scroll anchors en check of deze ook bestaat
		$('#'+scrollSection).each(function(index,value) {
			if($(this).length > 0) {

				// als je verder scrollt dan deze anchor maak menu item active
				if($(this).offset().top >= startScroll && $(this).offset().top <= endScroll) {

					// laatste link/id actief houden tot footer
					if(scrollActive==true) {
						if($('[data-scroll-children]').length>0) {
							$('body').find('a[data-scroll-link]').parent().removeClass('active');
							$('body').find('a[data-scroll-link="'+$(this).attr('id')+'"]').parent().addClass('active');
							$('body').find('a[data-scroll-children~="'+$(this).attr('id')+'"]').parent().addClass('active');
						} else {
							$('body').find('a[data-scroll-link]').parent().removeClass('active');
							$('body').find('a[data-scroll-link="'+$(this).attr('id')+'"]').parent().addClass('active');
						}
					} else {
						if($('[data-scroll-parent]').length>0) {
							$('body').find('a[data-scroll-link]').parent().removeClass('active');
							$('body').find('a[data-scroll-link="'+$(this).attr('id')+'"]').parent().addClass('active');
							$('body').find('a[data-scroll-parent="'+$(this).attr('id')+'"]').parent().addClass('active');
						} else {
							$('body').find('a[data-scroll-link]').parent().removeClass('active');
							$('body').find('a[data-scroll-link="'+$(this).attr('id')+'"]').parent().addClass('active');
						}
					}

				}
			}
		});
	});
}
